<template>
  <div class="footer" v-if="notificationTime">
    <!-- <h2></h2>
    <div :show="dismissCountDown" role="alert" class="alert" :class="notificationType" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
      <p>{{notification}} - {{dismissCountDown}}</p>
    </div>-->
    <div class=" col-4 alert alert-success alert-dismissible fade show" role="alert" ref="alert">
      <p>{{notification}}</p>
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>
<script>
import { bus } from '../common/bus'
export default {
  name: 'notify',
  data () {
    return {
      notification: 'test notification',
      notificationTime: false,
      dismissCountDown: 5000
      // notificationType: 'success'
    }
  },
  created () {
    bus.$on('success', text => {
      this.notification = text || 'ოპერაცია წარმატებით დასრულდა'
      this.notificationTime = true
      this.countInterval()
      // this.notificationType = 'alert-success'
      // this.showAlert()
    })
    bus.$on('error', error => {
      this.notification = error.response.data.message
      // this.notificationType =
      //   error.response.status === 500 ? 'danger' : 'warning'
      // this.showAlert()
      this.notificationTime = true
      this.countInterval()
    })
    bus.$on('warning', text => {
      this.notification = text
      // this.notificationType = 'warning'
      // this.showAlert()
      this.notificationTime = true
      this.countInterval()
    })
  },
  methods: {
    // countDownChanged (dismissCountDown) {
    //   this.dismissCountDown = dismissCountDown
    // },
    // showAlert () {
    //   this.dismissCountDown = this.dismissSecs
    // },
    countInterval () {
      setInterval(() => {
        this.notificationTime = false
      }, this.dismissCountDown)
    }
  }
}
</script>
<style scoped>
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  height: 70px;
  width: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/common/notify.vue